__turbopack_context__.v({
  "container": "CategoryNavCarousel-module-scss-module__PN65Pa__container",
  "swiper": "CategoryNavCarousel-module-scss-module__PN65Pa__swiper",
  "swiperSlide": "CategoryNavCarousel-module-scss-module__PN65Pa__swiperSlide",
  "titleContainer": "CategoryNavCarousel-module-scss-module__PN65Pa__titleContainer",
});
